import { mediaItems } from '@/mocks/darkwebData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            暗网影像
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            暗网重大事件视频解读与专题报道
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors"></div>
                <div className="absolute bottom-2 right-2 bg-foreground-950/75 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-2 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                  {item.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.views} 次观看</span>
                  <span>{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}